var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvalidImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.311 2.725 20 19 1.378-1.45-20-19-1.378 1.45zM22.18 17.724c.245-1.972.32-3.453.32-5.724 0-2.095-.282-5.016-.423-6.357a1.984 1.984 0 0 0-1.667-1.75c-5.118-.805-8.685-1.008-13.308-.495l1.925 1.829c3.645-.271 6.767-.035 11.062.64.143 1.352.411 4.164.411 6.133 0 1.585-.037 2.755-.145 3.989l1.826 1.735z",
    fill: "#313030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 10.998 13 9.002V9a2 2 0 1 1 2.1 1.998zM1.96 5.411l1.824 1.732C3.65 8.594 3.5 10.531 3.5 12c0 .152.002.309.005.47l2.74-2.99 1.45 1.378-3.958 4.318c.04.544.063 1.055.083 1.519.023.528.044.994.084 1.38 1.665.137 5.455.425 8.096.425a86.47 86.47 0 0 0 3.671-.064l1.987 1.888c-1.786.131-3.417.176-5.658.176-2.743 0-6.627-.297-8.277-.434A1.976 1.976 0 0 1 1.917 18.3C1.774 16.936 1.5 14.066 1.5 12c0-2.097.282-5.024.424-6.363.008-.077.02-.152.037-.226z",
    fill: "#313030"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidImage);
export default __webpack_public_path__ + "static/media/invalid-image.2fd867feb04a71443fa09d080f7dcadb.svg";
export { ForwardRef as ReactComponent };